import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const apivoid = defineConnector({
  identifier: "apivoid",
  name: "APIVoid",
  tagLine: "Threat intelligence APIs",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://api\\.apivoid\\.com/.*",
  auth: (app) => headerAuth([{ name: "X-API-Key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Sign in to [APIVoid](https://www.apivoid.com/), open **My API Keys**, create a new key if needed, and copy it.",
        },
      ],
    },
    {
      title: "Copy and paste the API key into the field below",
      items: [
        {
          kind: "input",
          label: "APIVoid API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => ({
      url: "https://api.apivoid.com/v2/account-info",
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: "{}",
    }),
  },
});
